module.exports = __webpack_public_path__ + "static/media/step-solution3.1f66b530.svg";